import { render, staticRenderFns } from "./AddToHomeScreen.vue?vue&type=template&id=7b809dc6&"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=js&"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports